export default "__VITE_ASSET__96f55797__"